    
import api from '../../api/axiosClient';
import { CategoryRowType } from '../../types/categories';
import { ModelsDetailRowType } from '../../types/models';
import { Options } from '../../types/recipes';

interface TextileTypeOptionResponse {
  id: number;
  name: string;
  code?: string;
}

type CreateOptionsResult = {
  color_options: Options[];
  recycling_options: Options[];
  reuse_options: Options[];
  textile_options: Options[];
  color_label_options: Options[];
};

const toOptionMap = (categories: CategoryRowType[]) => {
  return new Map(categories.map((category) => [category.id, category.name]));
};

const toOptions = (ids: number[], labels: Map<number, string>) => {
  return ids
    .filter((categoryId, index, source) => source.indexOf(categoryId) === index)
    .map((categoryId) => ({
      value: String(categoryId),
      label: labels.get(categoryId) ?? String(categoryId),
    }));
};

export const CreateOptions = async (id: number): Promise<CreateOptionsResult> => {
  const recipeInfo = await api.get(`/sorter/recipe/${id}`);
  const sorter_color_model_id = recipeInfo.data.sorter_color_model_id;
  const sorter_reuse_model_id = recipeInfo.data.sorter_reuse_model_id;
  const sorter_recycling_model_id = recipeInfo.data.sorter_recycling_model_id;

  const [colorsModel, recyclingModel, reuseModel, recyclingCategories, reuseCategories, colorCategories, textileTypes] = await Promise.all([
    api.get<ModelsDetailRowType[]>(`/sorter/model/colors/model/${sorter_color_model_id}`),
    api.get<ModelsDetailRowType[]>(`/sorter/model/recycling-categories/model/${sorter_recycling_model_id}`),
    api.get<ModelsDetailRowType[]>(`/sorter/model/reuse-categories/model/${sorter_reuse_model_id}`),
    api.get<CategoryRowType[]>(`/categories/getAll`),
    api.get<CategoryRowType[]>(`/sorter/reuse-category`),
    api.get<CategoryRowType[]>(`/colors/getAll`),
    api.get<TextileTypeOptionResponse[]>(`/textil-types/options`),
  ]);


  const colorIds = colorsModel.data
    .map((item) => item.color_id)
    .filter((value): value is number => value !== undefined);
  const recyclingIds = recyclingModel.data
    .map((item) => item.recycling_category_id)
    .filter((value): value is number => value !== undefined);
  const reuseIds = reuseModel.data
    .map((item) => item.reuse_category_id)
    .filter((value): value is number => value !== undefined);

  const colorLabels = toOptionMap(colorCategories.data.filter((category) => !category.deleted));
  const recyclingLabels = toOptionMap(recyclingCategories.data.filter((category) => !category.deleted));
  const reuseLabels = toOptionMap(reuseCategories.data.filter((category) => !category.deleted));

  const color_options = toOptions(colorIds, colorLabels);
  const recycling_options = toOptions(recyclingIds, recyclingLabels);
  const reuse_options = toOptions(reuseIds, reuseLabels);
  const color_label_options = Array.from(colorLabels.entries()).map(([categoryId, name]) => ({
    value: String(categoryId),
    label: name,
  }));
  const textile_options = textileTypes.data.map((item) => ({
    value: String(item.id),
    label: item.code || item.name,
  }));

  return {
    color_options,
    recycling_options,
    reuse_options,
    textile_options,
    color_label_options,
  };
};